export interface Chapter {
  category: number;
  bookId: string;
  chapterId: string;
  chapterNid: string;
  title: string;
  createdAt: Date;
  updatedAt: Date;
  published: boolean;
  position: number;
  totalView?: number;
  totalComment?: number;
  bookNid?: string;
  userId: string;
  book: any | null;
  audience: number;
}

export function Chapter(params: Partial<Chapter>) {
  return {
    bookId: params.bookId ?? '',
    chapterId: params.chapterId ?? '',
    title: params.title ?? 'no title',
    createdAt: params.createdAt ?? new Date(),
    updatedAt: params.updatedAt ?? new Date(),
    published: params.published,
    position: params.position,
    totalView: 0,
    totalComment: 0,
    book: params.book ?? {},
  } as Chapter;
}
